// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
      <path
        d="M3.06348 7.38984V3.33984H7.11348V4.33984H4.06348V7.38984H3.06348ZM3.06348 21.3398V17.2898H4.06348V20.3398H7.11348V21.3398H3.06348ZM17.0135 21.3398V20.3398H20.0635V17.2898H21.0635V21.3398H17.0135ZM20.0635 7.38984V4.33984H17.0135V3.33984H21.0635V7.38984H20.0635ZM17.0135 17.2898H18.2135V18.4898H17.0135V17.2898ZM17.0135 14.8648H18.2135V16.0648H17.0135V14.8648ZM15.7885 16.0648H17.0135V17.2898H15.7885V16.0648ZM14.5885 17.2898H15.7885V18.4898H14.5885V17.2898ZM13.3635 16.0648H14.5885V17.2898H13.3635V16.0648ZM15.7885 13.6398H17.0135V14.8648H15.7885V13.6398ZM14.5885 14.8648H15.7885V16.0648H14.5885V14.8648ZM13.3635 13.6398H14.5885V14.8648H13.3635V13.6398ZM18.2135 6.18984V11.0398H13.3635V6.18984H18.2135ZM10.7635 13.6398V18.4898H5.91348V13.6398H10.7635ZM10.7635 6.18984V11.0398H5.91348V6.18984H10.7635ZM9.86348 17.6148V14.5398H6.78848V17.6148H9.86348ZM9.86348 10.1398V7.06484H6.78848V10.1398H9.86348ZM17.3385 10.1398V7.06484H14.2635V10.1398H17.3385Z"
        fill="#323433"
      />
    </svg>
  );
}
